import { usePlatformList } from "@/pages/consumption/hooks/usePlatformList";

export function usePlatformOptions() {
  const { platformList } = usePlatformList();
  return platformList
    .filter((i) => i.aiPlatform !== 1)
    .map((p) => ({
      label: p.label,
      value: p.platform,
    }));
}
